import Icon from '@klv/atoms/icon';

import { generateClassName } from '@klv/shared/utils/functions';

import * as s from './styles/toggle.module.css';

import type { IToggle } from './types';

const Toggle = ({
  label,
  trueIcon,
  falseIcon,
  className,
  value = true,
  setValue,
  falseText,
  trueText,
  wide = false,
  rounded = false,
  backgroundColor = 'lightSand',
  toggleColor,
  variant,
}: IToggle) => {

  return (
    <div className={generateClassName([
      s.toggle,
      className,
      wide && s.wide,
      rounded && s.rounded,
      backgroundColor === 'dark' && s.darkVariant,
      backgroundColor === 'white' && s.lightVariant,
      variant === 'pricing' && s.pricing,
    ])}>
      <div className="p3">{label}</div>
      <div className={`${s.toggleButtonContainer} ${variant === 'short' && s.short}`}>
        <button onClick={() => !value && setValue(true)} className={`${s.toggleButton} ${value && s.selected} ${toggleColor === 'lavender' && s.lavender}`} type="button">
          {trueIcon && <Icon iconName={trueIcon} size={2.4} />}
          {trueText ? <p className={`${s.text} ${variant === 'short' && s.short}  ${variant === 'pricing' && s.pricingText}` }>{trueText}</p> : null}
        </button>
        <button onClick={() => value && setValue(false)} className={`${s.toggleButton} ${!value && s.selected} ${toggleColor === 'lavender' && s.lavender}`} type="button">
          {falseIcon && <Icon iconName={falseIcon} size={2.4} />}
          {falseText ? <p className={`${s.text} ${variant === 'short' && s.short}`}>{falseText}</p> : null}
        </button>
      </div>
    </div>
  );
};

export default Toggle;
